import React from "react";
import { Link, } from "react-router-dom";

// --------------------------------------------------

export default () => (
	<div>
		<h1>Private</h1>
		<Link to = "/upload">Upload</Link>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/Private.js